/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Insert_Speaker_Manage_LabelInputs */

const en_insert_speaker_manage_label = /** @type {(inputs: Insert_Speaker_Manage_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open speaker manager`)
};

const fr_insert_speaker_manage_label = /** @type {(inputs: Insert_Speaker_Manage_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir le gestionnaire de locuteurs`)
};

const de_insert_speaker_manage_label = /** @type {(inputs: Insert_Speaker_Manage_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Speaker Manager`)
};

const it_insert_speaker_manage_label = /** @type {(inputs: Insert_Speaker_Manage_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responsabile degli oratori aperti`)
};

const ru_insert_speaker_manage_label = /** @type {(inputs: Insert_Speaker_Manage_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Менеджер открытых выступлений`)
};

const es_insert_speaker_manage_label = /** @type {(inputs: Insert_Speaker_Manage_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestor de oradores abierto`)
};

const zh_cn2_insert_speaker_manage_label = /** @type {(inputs: Insert_Speaker_Manage_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开放式演讲者管理`)
};

const ja_insert_speaker_manage_label = /** @type {(inputs: Insert_Speaker_Manage_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スピーカーマネージャーを開く`)
};

const hi_insert_speaker_manage_label = /** @type {(inputs: Insert_Speaker_Manage_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ओपन स्पीकर मैनेजर`)
};

const pt_pt2_insert_speaker_manage_label = /** @type {(inputs: Insert_Speaker_Manage_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerente de palestrantes aberto`)
};

/**
* | output |
* | --- |
* | "Open speaker manager" |
*
* @param {Insert_Speaker_Manage_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const insert_speaker_manage_label = /** @type {((inputs?: Insert_Speaker_Manage_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insert_Speaker_Manage_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_insert_speaker_manage_label(inputs)
	if (locale === "de") return de_insert_speaker_manage_label(inputs)
	if (locale === "it") return it_insert_speaker_manage_label(inputs)
	if (locale === "ru") return ru_insert_speaker_manage_label(inputs)
	if (locale === "es") return es_insert_speaker_manage_label(inputs)
	if (locale === "zh-CN") return zh_cn2_insert_speaker_manage_label(inputs)
	if (locale === "ja") return ja_insert_speaker_manage_label(inputs)
	if (locale === "hi") return hi_insert_speaker_manage_label(inputs)
	if (locale === "pt-PT") return pt_pt2_insert_speaker_manage_label(inputs)
	return en_insert_speaker_manage_label(inputs)
});